/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { Button } from './ui/button';
import { Apple, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

import Card from './Card';

import firebase from 'firebase/app';
import Store from './Store';
import GoogleIcon from './GoogleIcon';

function VerifyAccount() {
  let [done, setDone] = React.useState(false);
  let onApple = async () => {
    try {
      var provider = new firebase.auth.OAuthProvider('apple.com');
      let currentUser = firebase.auth().currentUser;
      await currentUser.linkWithPopup(provider);
      // HACK: firebase is dumb
      window.location.reload();
      setDone(true);
    } catch (e) {
      Store.onFailure(e);
    }
  };

  let onGoogle = async () => {
    try {
      let provider = new firebase.auth.GoogleAuthProvider();

      let currentUser = firebase.auth().currentUser;
      await currentUser.linkWithPopup(provider);
      // HACK: firebase is dumb
      window.location.reload();
      /*
      firebase
        .auth()
        .signInWithCredential(
          firebase.auth.GoogleAuthProvider.credential(
            '{"sub": "abc123", "email": "foo@example.com", "email_verified": true}',
          ),
        );
        */
      setDone(true);
    } catch (e) {
      Store.onFailure(e);
    }
  };

  if (done) {
    return null;
  }

  return (
    <Card className="p-4">
      <div className="flex flex-col justify-center">
        <Button
          variant="default"
          className="mt-1 mb-1 w-[250px] bg-black text-white hover:bg-gray-800"
          onClick={onApple}
        >
          <Apple className="mr-2 h-4 w-4" />
          Continue with Apple
        </Button>
        <Button variant="default" asChild className="mt-1 mb-1 w-[250px]">
          <Link to="/login_with_email">
            <Mail className="mr-2 h-4 w-4" />
            Continue with Email
          </Link>
        </Button>

        <Button
          variant="default"
          className="mt-1 mb-1 w-[250px]"
          onClick={onGoogle}
        >
          <GoogleIcon className="mr-2 h-4 w-4" />
          Continue with Google
        </Button>
      </div>
    </Card>
  );
}

export default VerifyAccount;
